module.exports = __webpack_public_path__ + "static/media/12.52fece28.jpg";